import { render, staticRenderFns } from "./FormSuplencia.vue?vue&type=template&id=5151244e&"
import script from "./FormSuplencia.vue?vue&type=script&lang=js&"
export * from "./FormSuplencia.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports